import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './testimonials.component.scss';
var Testimonials = /** @class */ (function (_super) {
    tslib_1.__extends(Testimonials, _super);
    function Testimonials(element) {
        return _super.call(this, element) || this;
    }
    Testimonials.prototype.init = function () { };
    Testimonials.prototype.bindEvents = function () { };
    return Testimonials;
}(Base));
export { Testimonials };



//////////////////
// WEBPACK FOOTER
// ./components/testimonials/testimonials.component.ts
// module id = 540
// module chunks = 0